

export enum ProfileExternalInfoSource {
    AIAgent = 'agent_inference',
    TagRule = 'tagRules'
}

export class ProfileExternalInfo {
    profileId?: string;

    created?: Date;

    updated?: Date;

    attributeName?: string;

    attributeValue?: string;

    source?: string;


}